import IMask from 'imask';

import { ID_CARD_NUMBER_MASK, LASER_NUMBER_MASK } from './constants';

export const idCardNumberFormatter = IMask.createPipe({
  mask: ID_CARD_NUMBER_MASK,
});

export const laserNumberFormatter = IMask.createPipe({
  mask: LASER_NUMBER_MASK,
});

export function removeDashes(value: string) {
  return value.replace(/-/g, '');
}
